import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Image, Row } from 'react-bootstrap'
import {
  createSearchParams,
  useNavigate,
  useSearchParams
} from 'react-router-dom'
import StapMainLayout from './step-main'
import {
  EMP_CHECK_LIST_DETAIL_ST_1,
  EMP_CHECK_LIST_DETAIL_ST_3
} from '../../../../router/routes'
import { BsChevronDoubleLeft, BsChevronDoubleRight } from 'react-icons/bs'
import { useForm } from 'react-hook-form'
import SwalCustom from '../../../../alert/swal-custom'
import {
  getChecklistNewStepDetailAPI,
  putChecklistNewFiveAPI
} from '../../../../services/checklist'
import Error_500 from '../../../error/error-500'
import Error_false from '../../../error/error-false'
import { TXTSUCCESS } from '../../../../Constants'
import moment from 'moment'
import styled from 'styled-components'
import ImgCheckbox from '../../../../images/checkbox.svg'
import SwalCustomSuccess from '../../../../alert/swal-success'

export default function StapPage5(step) {
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm()
  let [searchParams, setSearchParams] = useSearchParams()
  const org = searchParams.get('org')
  const code = searchParams.get('code')
  const clnNo = searchParams.get('id')
  const status = searchParams.get('status')

  const [stepId, setStepId] = useState([])
  const [hasEdit, setHasEdit] = useState([])
  const [createDate, setCreateDate] = useState([])
  const [detail_1, setDetail_1] = useState([])
  const [detail_2, setDetail_2] = useState([])
  const [dataStep, setDataStep] = useState([])
  const [approve, setApprove] = useState()
  const [isSubmit, setIsSubmit] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [typeComCheck, setTypeComCheck] = useState(0)

  useEffect(() => {
    getStep()
    return () => {}
  }, [])

  const getStep = async (stepId = 5) => {
    try {
      setIsLoading(true)
      const resp = await getChecklistNewStepDetailAPI({
        stepId,
        clnNo
      })
      setIsLoading(false)

      if (!resp) return
      if (resp.status) {
        setCreateDate(resp.result.insert_date)
        setHasEdit(resp.result.has_edit) //computer
        setStepId(resp.result.step_id)
        setApprove(resp.result.approve)
        setDataStep(resp.result.result)
        setDetail_1(
          resp.result.result.length > 0 ? resp.result.result[0].groups : []
        )
        setDetail_2(
          resp.result.result.length > 1 ? resp.result.result[1].groups : 0
        )
        const f3 = resp.result.result[1].groups.filter((d) => d.is_check === 1)
        const dataTypeCom = resp.result.result[0].groups.filter(
          (d) => d.is_check === 1
        )
        setTypeComCheck(
          dataTypeCom && dataTypeCom.length > 0 ? dataTypeCom[0]?.id : 0
        )
      } else {
        setDataStep([])
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const nevigate = useNavigate()

  const fnBack = () => {
    nevigate(
      {
        pathname: EMP_CHECK_LIST_DETAIL_ST_1,
        search: `?${createSearchParams({
          code,
          org,
          id: clnNo,
          status: status
        })}`
      },
      { replace: true }
    )
  }
  const fnNext = () => {
    nevigate(
      {
        pathname: EMP_CHECK_LIST_DETAIL_ST_3,
        search: `?${createSearchParams({
          code,
          org,
          id: clnNo,
          status: status
        })}`
      },
      { replace: true }
    )
  }
  const onSubmit = async () => {
    try {
      setIsSubmit(true)
      setIsLoading(true)
      const e1 = {
        equipId: dataStep[0].equip_pd_group_id,
        id: typeComCheck,
        detail: ''
      }
      const e2 = detail_2.filter((d) => d.is_check === 1)
      const e2New = e2.map((d, id) => {
        return {
          id: d.id,
          detail: d.detail ?? '',
          equipId: dataStep[1].equip_pd_group_id
        }
      })
      const equips = [e1, ...(typeComCheck !== 8 ? e2New : [])]
      const body = { equips }
      if ((typeComCheck > 0 && e2New.length === 2) || typeComCheck === 8) {
        const param = { clnNo }

        const resp = await putChecklistNewFiveAPI(param, body)
        setIsSubmit(false)
        setIsLoading(false)
        if (!resp) return
        if (resp.status) {
          SwalCustomSuccess().then(() => {
            getStep()
          })
        } else {
          Error_false(resp)
        }
      } else {
        SwalCustom({
          title: 'ตรวจสอบข้อมูล',
          text: 'โปรดกรอกข้อมูลให้ครบถ้วนก่อนกดยืนยัน',
          confirmButtonColor: '#f9af29',
          showConfirmButton: true
        })
        setIsSubmit(false)
        setIsLoading(false)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const handleInputChange_2 = (id, value) => {
    if (value) {
      setDetail_2((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1,
              detail: value
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setDetail_2((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0,
              detail: value
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }
  return (
    <>
      {isLoading && <div className="preloader"></div>}
      <Form className="row" onSubmit={handleSubmit(onSubmit)}>
        <Col
          xl={12}
          className="mt-3 mb-3"
          style={{ position: 'sticky', top: 0, zIndex: 1000 }}
        >
          <StapMainLayout current={1} />
        </Col>

        <div className="mt-2 mb-3">
          <span className="fw-bold me-2">เลขเอกสาร: </span>
          <span className="">{clnNo}</span>{' '}
          <span className="fw-light me-2">
            {createDate
              ? moment(createDate).format('DD/MM/YYYY HH:mm')
              : ''}{' '}
          </span>
        </div>
        {dataStep.length > 0 &&
          dataStep.map((d, i) => (
            <Col xl={12} key={i}>
              {d.equip_pd_group_id === 3 ? (
                <>
                  {/* ประเภทของคอมพิวเตอร์ */}
                  <div className="fw-bold mt-2 mb-2">{d.equip_pd_group}</div>
                  <div className="m-4 mt-1 me-0 d-flex">
                    <CheckboxRadioCustom className="fw-light">
                      {detail_1.map((option, index) => (
                        <>
                          <Form.Check
                            key={`dataDetail-1-${index}`}
                            inline
                            checked={
                              option.is_check === 1 &&
                              typeComCheck === option.id
                                ? true
                                : typeComCheck === option.id
                                  ? true
                                  : false
                            }
                            label={option.equip_pd_name}
                            name={`typeCom`}
                            type="radio"
                            onChange={() =>
                              !approve && setTypeComCheck(option.id)
                            }
                          />
                        </>
                      ))}
                    </CheckboxRadioCustom>
                  </div>
                </>
              ) : d.equip_pd_group_id === 4 ? (
                <>
                  {/* เครื่องคอมพิวเตอร์ */}
                  {typeComCheck !== 8 && (
                    <>
                      <div className="fw-bold mt-2 mb-3">
                        {d.equip_pd_group}
                      </div>
                      <div className="m-4 mt-1 me-0">
                        {detail_2
                          .sort((a, b) => a.id - b.id)
                          .map((option, index) => (
                            <>
                              {/* checkbox */}
                              <input
                                checked={option.is_check === 1 ? true : false}
                                name={`group2`}
                                type="checkbox"
                                id={`inline-group2-${index}`}
                                className="form-check-input"
                              />
                              <label
                                className="m-2 mt-0 mt-0 me-0"
                                htmlFor={`checkbox-radio-${index}`}
                              >
                                {option.equip_pd_name}
                              </label>
                              <div className="form-check-label mb-2 w-50">
                                <div
                                  style={{
                                    marginLeft: '35px',
                                    minWidth: '100px'
                                  }}
                                >
                                  {/* input */}
                                  <Form.Control
                                    disabled={approve}
                                    onChange={(e) => {
                                      handleInputChange_2(
                                        option.id,
                                        e.target.value
                                      )
                                    }}
                                    value={option.detail}
                                  />
                                </div>
                              </div>
                            </>
                          ))}
                      </div>
                    </>
                  )}
                </>
              ) : null}
            </Col>
          ))}
        {approve ? (
          <div className=" mt-5 font-small-2 d-flex justify-content-center">
            <div style={{ width: 300 }}>
              <div className="d-flex justify-content-center">
                {approve?.url === '' ? (
                  <span className="text-secondary ">ไม่พบลายเซ็น</span>
                ) : (
                  <Image width={250} fluid src={approve?.url} />
                )}
              </div>
              <div className="d-flex justify-content-center">
                ลงชื่อ
                <div
                  style={{
                    borderBottom: '1px dashed rgb(135, 135, 135)',
                    width: 200
                  }}
                ></div>{' '}
                ผู้ดำเนินการ
              </div>
              <div className="d-flex justify-content-center mt-3">
                ({approve?.title_th} {approve?.name_th} {approve?.surname_th})
              </div>
              <div className="d-flex justify-content-center fw-light mt-1">
                {approve?.position_th}
              </div>
              <div className="d-flex justify-content-center fw-light">
                {moment(approve.confirm_date5).format('DD/MM/YYYY')}
              </div>
            </div>
          </div>
        ) : (
          <Col xl={12} className="mt-5 text-center">
            <Button
              disabled={isSubmit}
              className="px-4 rounded-3"
              style={{ minWidth: 150 }}
              type="submit"
            >
              {isSubmit ? 'Submiting...' : 'Submit'}
            </Button>
          </Col>
        )}
      </Form>
      <div
        className="d-flex justify-content-between mt-5 mb-3 pe-4"
        style={{ position: 'sticky', bottom: 0, zIndex: 1000 }}
      >
        <span
          className=" border-0 p-3 small pointer-event bg-white pe-2"
          onClick={fnBack}
        >
          <BsChevronDoubleLeft className="ms-2 " /> Back
        </span>

        {approve && (
          <span className=" border-0 p-3 small pointer-event " onClick={fnNext}>
            Next
            <BsChevronDoubleRight className="ms-2 " />
          </span>
        )}
      </div>
    </>
  )
}
const CheckboxRadioCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 1rem;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: #2c5dfe !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid #2c5dfe;
  }
  label {
    margin: 0em 0em 0em 1em;
  }
  .form-check .form-check-input {
    float: left;
    margin-left: 0em;
  }
`
